// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  //   DashboardService: "https://localhost:44342/Customer",
  //  ServiceLocationAndOperationServiceLoad: "https://localhost:44342/CustomerSiteOperation",
  //  CustomerService: "https://localhost:44342/Customer",
  //  CustomerinformationService: "https://localhost:44342/CustomerSite",
  //  ExistingvendorService: "https://localhost:44342/CustomerSiteVendor",
  //  TradereferenceService: "https://localhost:44342/CustomerSiteTradeReference",
  //  SUKService: "https://localhost:44342/CustomerSiteSKU",
  //  PrequotesignoffService: "https://localhost:44342/CustomerSite",
  //  CustomerSiteCostAndContract:"https://localhost:44342/CustomerSiteContract",
  //  ContractconversionService:"https://localhost:44342/PrequoteContractConversion",
  //  UserService:"https://localhost:44342/User",
  //  PrequoteApproval:"https://localhost:44342/PrequoteApproval",
  //  Approval:"https://localhost:44342/Approval",
  //  Report:"https://localhost:44342/Report",
  //  PrequoteReport:"https://localhost:44342/PrequoteReport",
  //  Url:"https://localhost:44342",
  //  LogOutUrl:"http://anchordev.ponpurelogistics.com:8059",
  //  CustomerContract:"https://localhost:44342/CustomerContract",



  //  APIServiceDriving: "https://kyc-api.aadhaarkyc.io/api/v1/driving-license/driving-license?id_number=",
  //  APIServiceGST: "https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin?id_number=",
  //  APIServiceGOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/generate-otp?id_number=",
  //  APIServiceVOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/submit-otp?client_id=",
 


   
/* ************************************************** DEV ********************************************************* */
  
  // DashboardService: "http://anchordev.ponpurelogistics.com:8054/Customer",
  // ServiceLocationAndOperationServiceLoad: "http://anchordev.ponpurelogistics.com:8054/CustomerSiteOperation",
  // CustomerService: "http://anchordev.ponpurelogistics.com:8054/Customer",
  // CustomerinformationService: "http://anchordev.ponpurelogistics.com:8054/CustomerSite",
  // ExistingvendorService: "http://anchordev.ponpurelogistics.com:8054/CustomerSiteVendor",
  // TradereferenceService: "http://anchordev.ponpurelogistics.com:8054/CustomerSiteTradeReference",
  // SUKService: "http://anchordev.ponpurelogistics.com:8054/CustomerSiteSKU",
  // PrequotesignoffService: "http://anchordev.ponpurelogistics.com:8054/CustomerSite",
  // CustomerSiteCostAndContract: "http://anchordev.ponpurelogistics.com:8054/CustomerSiteContract",
  // ContractconversionService: "http://anchordev.ponpurelogistics.com:8054/PrequoteContractConversion",

  // UserService:"http://anchordev.ponpurelogistics.com:8054/User",
  // PrequoteApproval:"http://anchordev.ponpurelogistics.com:8054/PrequoteApproval",
  // Approval:"http://anchordev.ponpurelogistics.com:8054/Approval",
  // Report:"http://anchordev.ponpurelogistics.com:8054/Report",
  // PrequoteReport:"http://anchordev.ponpurelogistics.com:8054/PrequoteReport",
  // Url:"http://anchordev.ponpurelogistics.com:8054",
  // LogOutUrl:"http://anchordev.ponpurelogistics.com:8059",
  // CustomerContract:"http://anchordev.ponpurelogistics.com:8054/CustomerContract",

  // APIServiceDriving: "https://kyc-api.aadhaarkyc.io/api/v1/driving-license/driving-license?id_number=",
  // APIServiceGST: "https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin?id_number=",
  // APIServiceGOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/generate-otp?id_number=",
  // APIServiceVOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/submit-otp?client_id=",

  /* ************************************************** UAT ********************************************************* */

  DashboardService: "https://crmservice.ponpurelogistics.com/Customer",
  ServiceLocationAndOperationServiceLoad: "https://crmservice.ponpurelogistics.com/CustomerSiteOperation",
  CustomerService: "https://crmservice.ponpurelogistics.com/Customer",
  CustomerinformationService: "https://crmservice.ponpurelogistics.com/CustomerSite",
  ExistingvendorService: "https://crmservice.ponpurelogistics.com/CustomerSiteVendor",
  TradereferenceService: "https://crmservice.ponpurelogistics.com/CustomerSiteTradeReference",
  SUKService: "https://crmservice.ponpurelogistics.com/CustomerSiteSKU",
  PrequotesignoffService: "https://crmservice.ponpurelogistics.com/CustomerSite",
  CustomerSiteCostAndContract: "https://crmservice.ponpurelogistics.com/CustomerSiteContract",
  ContractconversionService: "https://crmservice.ponpurelogistics.com/PrequoteContractConversion",

  UserService:"https://crmservice.ponpurelogistics.com/User",
  PrequoteApproval:"https://crmservice.ponpurelogistics.com/PrequoteApproval",
  Approval:"https://crmservice.ponpurelogistics.com/Approval",
  Report:"https://crmservice.ponpurelogistics.com/Report",
  PrequoteReport:"https://crmservice.ponpurelogistics.com/PrequoteReport",
  Url:"https://crmservice.ponpurelogistics.com",
  LogOutUrl:"http://anchor.ponpurelogistics.com",
  CustomerContract:"https://crmservice.ponpurelogistics.com/CustomerContract",

  APIServiceDriving: "https://kyc-api.aadhaarkyc.io/api/v1/driving-license/driving-license?id_number=",
  APIServiceGST: "https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin?id_number=",
  APIServiceGOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/generate-otp?id_number=",
  APIServiceVOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/submit-otp?client_id=",

  /* ************************************************** LIVE ********************************************************* */
  
  // DashboardService: "https://crmservice.ponpurelogistics.com/Customer",
  // ServiceLocationAndOperationServiceLoad: "https://crmservice.ponpurelogistics.com/CustomerSiteOperation",
  // CustomerService: "https://crmservice.ponpurelogistics.com/Customer",
  // CustomerinformationService: "https://crmservice.ponpurelogistics.com/CustomerSite",
  // ExistingvendorService: "https://crmservice.ponpurelogistics.com/CustomerSiteVendor",
  // TradereferenceService: "https://crmservice.ponpurelogistics.com/CustomerSiteTradeReference",
  // SUKService: "https://crmservice.ponpurelogistics.com/CustomerSiteSKU",
  // PrequotesignoffService: "https://crmservice.ponpurelogistics.com/CustomerSite",
  // CustomerSiteCostAndContract: "https://crmservice.ponpurelogistics.com/CustomerSiteContract",
  // ContractconversionService: "https://crmservice.ponpurelogistics.com/PrequoteContractConversion",
  
  // UserService:"https://crmservice.ponpurelogistics.com/User",
  // PrequoteApproval:"https://crmservice.ponpurelogistics.com/PrequoteApproval",
  // Approval:"https://crmservice.ponpurelogistics.com/Approval",
  // Report:"https://crmservice.ponpurelogistics.com/Report",
  // PrequoteReport:"https://crmservice.ponpurelogistics.com/PrequoteReport",
  // Url:"https://crmservice.ponpurelogistics.com",
  // LogOutUrl:"https://anchor.ponpurelogistics.com/",
  // CustomerContract:"https://crmservice.ponpurelogistics.com/CustomerContract",
  
  // APIServiceDriving: "https://kyc-api.aadhaarkyc.io/api/v1/driving-license/driving-license?id_number=",
  // APIServiceGST: "https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin?id_number=",
  // APIServiceGOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/generate-otp?id_number=",
  // APIServiceVOTP: "https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/submit-otp?client_id=",
  
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
